import React from "react";
import { withRouteData } from "react-static";
import { GMAPS_LINK_PRAGUE_BRANCH } from "../constants";

export default withRouteData(
  ({ hideFooterMap }) =>
    hideFooterMap ? null : (
      <iframe
        id="map-container"
        frameBorder="0"
        style={{ border: 0 }}
        src={GMAPS_LINK_PRAGUE_BRANCH}
      />
    )
);
